export default __webpack_public_path__ + "static/media/Floor-Mops.23aaa119.jpg";